"use client";
import { useEffect, useState } from "react";
import Sider from "../../components/siderbarcomponents.jsx";
import { useNavigate } from "react-router-dom";

export default function Empresas() {
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  // Definir la estructura del formulario
  const [formData, setFormData] = useState({
    name: "",
    legalRepName: "",
    legalRepPhone: "",
    companyLogo: "",
    city: "",
    destinations: "",
    email: "",
    totalVehicles: 0, // Se inicializa como número
  });
  const navigate = useNavigate();

  //useefects para ejecutar la funcion que trae la data de las empresas
  useEffect(() => {
    getCompanies();
  }, []);

  console.log(empresas);

  //funcion para traer todas las empresas del backend
  const getCompanies = async () => {
    try {
      const response = await fetch(
        "https://dev-api-pixu.xervix.com.co/api/companies/get-all",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Empresas obtenidas:", data);
      setEmpresas(data); // Suponiendo que `setEmpresas` es tu estado
    } catch (error) {
      console.error("Error al obtener empresas:", error);
      alert((error as Error).message);
    }
  };

  //funcion para capturar los datos del modal para crear una empresa
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Si el campo es totalVehicles, convertirlo a número
    const newValue = name === "totalVehicles" ? Number(value) : value;

    setFormData({ ...formData, [name]: newValue });
  };

  //funcion para enviar nueva empresa al backend
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://dev-api-pixu.xervix.com.co/api/companies/create-company",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const responseData = await response.json();
      console.log("Response Data:", responseData);
      if (!response.ok) {
        throw new Error(
          `Error: ${response.status} - ${
            responseData.message || "Error desconocido"
          }`
        );
      }
      alert("Empresa registrada con éxito");
      setModalOpen(false);
      // Reiniciar los valores después del registro
      setFormData({
        name: "",
        legalRepName: "",
        legalRepPhone: "",
        companyLogo: "",
        city: "",
        destinations: "",
        email: "",
        totalVehicles: 0,
      });
    } catch (error) {
      console.error("Error en la solicitud:", error);
      alert((error as Error).message);
    }
  };

  return (
    <div className="flex h-screen bg-gray-100 ">
      <Sider />
      <div className="flex-1 p-6">
        <div className="flex justify-between items-center h-[10%] pt-10">
          <h1 className="text-[18px] font-semibold text-textSubtitle">
            EMPRESAS VINCULADAS A 25 DE FEBRERO DE 2025
          </h1>
          <button
            onClick={() => setModalOpen(true)}
            className="flex items-center bg-blue-600 text-white px-4 py-[6px] rounded-md hover:bg-bgSecundary"
          >
            <span className="text-[22px] pr-2">+ </span> Agregar Empresa
          </button>
        </div>

        {/* Tabla */}
        <div className="mt-6 bg-white h-[88%] shadow-md overflow-auto rounded-md">
          <table className="w-full border-collapse px-4">
            <thead>
              <tr className="border-b py-4">
                <th className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-semibold">
                  Nombre
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Representante
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Fecha Ingreso
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Ciudad
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  No. Buses
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Programación
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Teléfono
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Acción
                </th>
              </tr>
            </thead>
            <tbody>
              {empresas.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center py-4 text-gray-500">
                    No hay información disponible
                  </td>
                </tr>
              ) : (
                empresas.map((empresa, index) => (
                  <tr key={index} className="border-b hover:bg-gray-100 py-4">
                    <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-semibold">
                      {empresa.name}
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      {empresa.legalRepName}
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      {empresa.fechaIngreso}
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      {empresa.city}
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      {empresa.totalVehicles}
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      hola
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-semibold">
                      {empresa.legalRepPhone}
                    </td>
                    <td
                    onClick={() => navigate("/empresas/trucks", { state: { empresaName: empresa.name } })}
                      className="text-center text-[14px] text-textTipic font-semibold cursor-pointer"
                    >
                      Abrir
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {modalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-lg w-[65%]">
              <h2 className="text-xl font-bold mb-4">Registrar Empresa</h2>

              <form onSubmit={handleSubmit} className="">
                <div className="block xl:flex items-center justify-between mb-6">
                  <div className="w-full xl:w-1/2 px-4 ">
                    <label className="text-[12px] text-textTipic font-medium">
                      Nombre Empresa
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Nombre de la empresa"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                  <div className="w-full xl:w-1/2 px-4">
                    <label className="text-[12px] text-textTipic font-medium">
                      Nombre Representante
                    </label>
                    <input
                      type="text"
                      name="legalRepName"
                      placeholder="Nombre del representante"
                      value={formData.legalRepName}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                </div>
                <div className="block xl:flex items-center justify-between mb-6">
                  <div className="w-full xl:w-1/2 px-4"></div>
                  <div className="w-full xl:w-1/2 px-4">
                    <label className="text-[12px] text-textTipic font-medium">
                      Ciudad
                    </label>
                    <input
                      type="text"
                      name="city"
                      placeholder="Ciudad"
                      value={formData.city}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                </div>
                <div className="block xl:flex items-center justify-between mb-6">
                  <div className="w-full xl:w-1/2 px-4">
                    <label className="text-[12px] text-textTipic font-medium">
                      Número telefónico
                    </label>
                    <input
                      type="text"
                      name="legalRepPhone"
                      placeholder="Ingrese Teléfono"
                      value={formData.legalRepPhone}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                  <div className="w-full xl:w-1/2 px-4">
                    <label className="text-[12px] text-textTipic font-medium">
                      Número de buses
                    </label>
                    <input
                      type="number"
                      name="totalVehicles"
                      placeholder="Número de Buses"
                      value={formData.totalVehicles}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                </div>
                <div className="block xl:flex items-center justify-between mb-6 ">
                  <div className="w-full xl:w-1/2 px-4"></div>
                  <div className="w-full xl:w-1/2 px-4">
                    <label className="text-[12px] text-textTipic font-medium">
                      Destinos
                    </label>
                    <input
                      type="text"
                      name="destinations"
                      placeholder="Ingrese destinos separados por coma"
                      value={formData.destinations}
                      onChange={handleChange}
                      className="w-full border p-4 rounded text-textTipic text-[14px]"
                      required
                    />
                  </div>
                </div>

                <div className="flex justify-center mt-12 w-full">
                  <button
                    type="button"
                    onClick={() => setModalOpen(false)}
                    className="bg-gray-400 text-white px-4 py-4 rounded-md mr-4 w-[160px]"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-4 rounded-md ml-4 w-[160px]"
                  >
                    Crear Empresa
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
